// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b3c9520c","943":"806cbe05"}[chunkId] + ".chunk.js";
};